import React from 'react';
import defaultImg from '../../../../../assets/images/default-article.png';
import { months } from '../../../utils/contants';

export const ArticleCard = ({ articleData, heartButtonFunction }) => {
	const article = articleData.article;
	const img_url = articleData.cloudinary_image;
	const new_img_url = articleData.article.img_url;
	const interest_areas = articleData.interest_areas;
	const followed = articleData.followed;

	const postedInfo = (date) => {
		const dateData = date.split('-');

		var output =
			'Posted on ' +
			months[parseInt(dateData[1]) - 1] +
			' ' +
			dateData[2] +
			', ' +
			dateData[0];
		return output;
	};

	const formattedTitle = (title) => {
		return title.length > 70 ? (
			<>{title.substring(0, 69)}&hellip;</>
		) : (
			title
		);
	};

	return (
		<div className="columns small-12 dashboard-card article-card card">
			{heartButtonFunction ? (
				<div className="follow-container">
					{followed ? (
						<div
							className="primary-button follow-button"
							onClick={heartButtonFunction}
						>
							<p>Following</p>
						</div>
					) : (
						<div
							className="secondary-button follow-button"
							onClick={heartButtonFunction}
						>
							<p>Follow</p>
						</div>
					)}
				</div>
			) : null}
			<a href={'/articles/' + article.id}>
				<div className="row media-container">
					<img
						src={
							new_img_url
								? new_img_url
								: img_url
								? img_url
								: defaultImg
						}
					/>
				</div>
			</a>
			<div className="content-container">
				<div className="meta-container">
					{postedInfo(article.posted_on)}
				</div>
				<div className="title-container">
					<strong>{formattedTitle(article.title)}</strong>
				</div>
				<div className="tags-container row">
					<div className="column button-group">
						{interest_areas
							.slice(0, 3)
							.map((interest_area, index) => {
								return (
									<div className="tag-button" key={index}>
										<a
											href={
												'/organizations?interest_area=' +
												interest_area.id
											}
											key={index}
										>
											<p className="body-font">
												{interest_area.name}
											</p>
										</a>
									</div>
								);
							})}
						{interest_areas.length > 3 ? (
							<i className="fas fa-ellipsis-h" />
						) : null}
					</div>
				</div>
			</div>
		</div>
	);
};
